import { Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const StickyCallBar = () => {
  const handleTextClick = () => {
    const message = encodeURIComponent("I have water damage at my home. Can you help?");
    window.open(`sms:8303602600?body=${message}`);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-wtr-blue text-primary-foreground p-4 shadow-strong z-50 md:hidden">
      <div className="flex gap-3 max-w-sm mx-auto">
        <Button 
          variant="phone"
          size="lg"
          className="flex-1 bg-background text-wtr-blue hover:bg-secondary font-semibold"
          onClick={() => window.open('tel:830-360-2600')}
          aria-label="Call WTR Restoration now"
        >
          <Phone className="w-5 h-5" />
          Call Now
        </Button>
        
        <Button 
          variant="outline"
          size="lg" 
          className="flex-1 border-background text-background hover:bg-background hover:text-wtr-blue font-semibold"
          onClick={handleTextClick}
          aria-label="Text WTR Restoration a photo"
        >
          <MessageCircle className="w-5 h-5" />
          Text Photo
        </Button>
      </div>
    </div>
  );
};